import { useEffect } from "react";
import { useContentCardsStore } from "../stores/contentCardsStore";
import { fromWebSdkCard } from "../utils/normalise";

export const useContentCardsSubscription = (isBrazeReady: boolean) => {
  useEffect(() => {
    const braze = window.braze;

    if (!isBrazeReady || !braze) {
      return;
    }

    const { setCards } = useContentCardsStore.getState();

    const subscription = braze.subscribeToContentCardsUpdates((contentCards) =>
      setCards(contentCards.cards.map(fromWebSdkCard)),
    );

    // Segment's load is deferred to an idle callback, so the SDK only arrives
    // seconds after first paint. Its own cache answers immediately and saves
    // waiting on the refresh round-trip.
    const cached = braze.getCachedContentCards();

    if (cached) {
      setCards(cached.cards.map(fromWebSdkCard));
    }

    return () => {
      if (subscription) {
        braze.removeSubscription(subscription);
      }
    };
  }, [isBrazeReady]);
};
